// Shows the Pixie (Ask) tab once the load-time availability check confirms it.
import { setApplicationValue } from "@/stores/experience/actions/layout";
import { valueNames } from "@/modules/Constants";
import { loadPixieFonts } from "@/modules/pixieFonts";
import { preloadPixieWhenIdle } from "@/components/shopwindow/ask/pixieChunk";
import ShopWindowConfigList from "@/plugin/ShopWindowConfigList";
import { shopWindowNames } from "@/plugin/recipeShopWindows";
import type ShopWindowConfig from "@/plugin/ShopWindowConfig";
import type { ExperienceState } from "@/types/state";

// Append the Ask config to the live shop-window list, so Pixie appears
// AFTER the availability check without re-running the whole build (which
// would reset the active tab / video-timeline default). A fresh list is
// dispatched so the store sees the change.
export function revealAsk(
  shopWindowMap: Record<string, ShopWindowConfig>,
  state: ExperienceState,
) {
  const applicationData = state.applicationData;
  const current = applicationData.getValue(
    valueNames.SHOP_WINDOW_CONFIG_LIST,
  ) as ShopWindowConfigList | undefined;
  if (!current || current.atName(shopWindowNames.ASK)) {
    return;
  }
  const askConfig = shopWindowMap[shopWindowNames.ASK];
  if (!askConfig || !askConfig.icon) {
    return;
  }
  // Start the Nunito/DM Sans download as the tab is revealed, so the fonts
  // are cached by the time the viewer first opens Pixie; the code follows on idle.
  loadPixieFonts();
  preloadPixieWhenIdle();
  const next = new ShopWindowConfigList();
  const list = current.asList;
  for (let i = 0; i < list.length; i++) {
    next.add(list[i]);
  }
  next.add(askConfig);
  // Dispatch through the store action, NOT applicationData.setValue: the
  // check resolves outside init's dispatch, and only the action emits a
  // store change.
  setApplicationValue("RecipePlugin", valueNames.SHOP_WINDOW_CONFIG_LIST, next);
}
